var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 858,
    height: 864,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.76940918 0.00182281 1.53881836 0.00364563 2.33154297 0.00552368 C19.45796703 0.07374317 34.95902064 2.51354625 51.4453125 7.12890625 C55.86558117 8.3589901 60.32525461 9.35963814 64.8125 10.3125 C64.8125 10.9725 64.8125 11.6325 64.8125 12.3125 C65.36719971 12.48193115 65.92189941 12.6513623 66.4934082 12.82592773 C71.95241407 14.55933971 76.95714771 16.66797302 82 19.375 C82.72977051 19.76494141 83.45954102 20.15488281 84.21142578 20.55664062 C91.52686647 24.55873864 98.21090174 29.23658597 104.8125 34.3125 C105.72 34.99570312 106.6275 35.67890625 107.5625 36.3828125 C142.04999862 63.37749148 163.51517845 101.58544782 169.52908325 144.79125977 C170.28163065 151.48582808 170.21548635 158.22066821 170.14868164 164.94848633 C170.12465725 167.53692842 170.1282087 170.124362 170.13476562 172.71289062 C170.12919935 174.38542274 170.12209613 176.05795061 170.11328125 177.73046875 C170.11419266 178.49095016 170.11510406 179.25143158 170.11604309 180.03495789 C170.05341594 184.77983266 169.27934086 188.75760906 167.8125 193.3125 C167.43761416 194.86874099 167.07654396 196.42842735 166.734375 197.9921875 C159.9108742 228.41838539 147.05249325 255.24136089 125.8125 278.3125 C125.23258301 278.9430127 124.65266602 279.57352539 124.05517578 280.22314453 C114.27153179 290.71935154 103.81442756 299.45951691 91.8125 307.3125 C91.11012207 307.77382324 90.40774414 308.23514648 89.68408203 308.71044922 C52.95277617 332.44439152 7.78985839 338.12641483 -34.625 329.625 C-62.62129766 323.60117677 -87.91918402 310.34807217 -109.1875 291.3125 C-110.03183594 290.58933594 -110.87617188 289.86617187 -111.74609375 289.12109375 C-116.69717442 284.85464818 -121.05511406 280.37154218 -125.1875 275.3125 C-126.02152344 274.30445313 -126.85554688 273.29640625 -127.71484375 272.2578125 C-145.34811409 250.61783643 -157.10095849 226.44127397 -162.9375 199.125 C-163.14858398 198.13927002 -163.35966797 197.15354004 -163.57714844 196.13793945 C-171.78169039 155.70463643 -163.88748385 111.52198853 -141.27246094 76.94238281 C-122.7056529 49.05039126 -96.92202839 24.42672865 -65.1875 12.3125 C-64.1975 12.3125 -63.2075 12.3125 -62.1875 12.3125 C-61.8575 11.6525 -61.5275 10.9925 -61.1875 10.3125 C-59.16210938 9.56640625 -59.16210938 9.56640625 -56.53125 8.875 C-55.59152344 8.61976563 -54.65179688 8.36453125 -53.68359375 8.1015625 C-51.68619792 7.57552083 -49.68880208 7.04947917 -47.69140625 6.5234375 C-46.28181641 6.14058594 -46.28181641 6.14058594 -44.84375 5.75 C-43.97556641 5.52183594 -43.10738281 5.29367187 -42.21289062 5.05859375 C-39.99867503 4.50544008 -39.99867503 4.50544008 -39.1875 2.3125 C-38.15625 2.35375 -37.125 2.395 -36.0625 2.4375 C-32.26225821 2.44949336 -28.70286625 1.94875579 -24.95703125 1.32421875 C-16.62343834 0.10519761 -8.41086673 -0.04147706 0 0 Z M-14.1875 52.3125 C-14.1875 58.5825 -14.1875 64.8525 -14.1875 71.3125 C-16.70375 71.828125 -19.22 72.34375 -21.8125 72.875 C-36.64561785 76.22063338 -51.01332417 83.39226488 -59.87890625 96.17578125 C-67.72769306 108.99156151 -70.94711305 122.52620016 -68.125 137.5 C-64.29002631 152.7539088 -56.06372825 163.88469223 -42.75048828 172.19335938 C-30.78465839 179.27718136 -17.40107187 182.94484712 -4.12597656 186.7434082 C5.17001701 189.47249649 16.04406335 192.84218874 21.75 201.125 C23.63516049 206.78048148 23.51358113 210.58900888 21.3125 216 C18.17910223 220.85565542 13.41107102 223.57812123 7.9375 225.125 C6.90625 225.186875 5.875 225.24875 4.8125 225.3125 C4.13058594 225.374375 3.44867188 225.43625 2.74609375 225.5 C-11.50370537 226.25122499 -24.03342806 219.91574183 -36.1875 213.3125 C-37.89679688 212.39597656 -37.89679688 212.39597656 -39.640625 211.4609375 C-42.16597615 210.09465777 -44.68162764 208.71408962 -47.1875 207.3125 C-56.70601443 215.95928852 -56.70601443 215.95928852 -62.1875 226.3125 C-62.78046875 226.54710937 -63.3734375 226.78171875 -63.984375 227.0234375 C-66.69844 228.61145425 -67.77243241 230.28852884 -69.4375 232.9375 C-69.95828125 233.75476563 -70.4790625 234.57203125 -71.015625 235.4140625 C-71.40234375 236.04054688 -71.7890625 236.66703125 -72.1875 237.3125 C-55.91190574 252.02313327 -36.39725088 257.17031468 -15.1875 260.3125 C-15.09662109 262.13587891 -15.09662109 262.13587891 -15.00390625 263.99609375 C-14.91951668 265.58074228 -14.8348679 267.16537702 -14.75 268.75 C-14.71068359 269.55244141 -14.67136719 270.35488281 -14.63085938 271.18164062 C-14.7820704 275.06489561 -14.7820704 275.06489561 -13.1875 278.3125 C-11.31985015 278.41232396 -9.44843962 278.44330757 -7.578125 278.4453125 C-6.43085938 278.44660156 -5.28359375 278.44789063 -4.1015625 278.44921875 C-2.28785156 278.44341797 -2.28785156 278.44341797 -0.4375 278.4375 C0.75617188 278.44136719 1.94984375 278.44523438 3.1796875 278.44921875 C4.33210938 278.44792969 5.48453125 278.44664062 6.671875 278.4453125 C8.25693848 278.44362061 8.25693848 278.44362061 9.87402344 278.44189453 C13.18081292 278.37125423 13.18081292 278.37125423 17.8125 277.3125 C17.8125 270.7125 17.8125 264.1125 17.8125 257.3125 C20.4525 256.9825 23.0925 256.6525 25.8125 256.3125 C33.92421925 253.90867292 41.09518372 250.44232552 47.8125 245.3125 C48.6375 244.68730469 49.4625 244.06210937 50.3125 243.41796875 C61.05967865 234.36682923 66.80008661 222.00939112 68.8125 208.3125 C69.96592132 193.93423424 66.88133496 180.45039807 57.625 169.125 C46.61267708 157.35483981 31.32990462 152.14853887 16.25 147.6875 C13.79000035 146.94652064 11.33036057 146.20434546 8.87109375 145.4609375 C7.69015137 145.10451172 6.50920898 144.74808594 5.29248047 144.38085938 C-17.9063319 137.25878817 -17.9063319 137.25878817 -21.8125 130.5625 C-23.67572206 126.04119508 -23.56717966 121.9678062 -22.1875 117.3125 C-19.65029315 112.98985129 -16.78539835 111.1891932 -12.1875 109.3125 C2.9844888 105.65998418 16.91340408 110.55751827 30.48364258 117.11352539 C33.99945283 118.8399304 33.99945283 118.8399304 37.82128906 119.11499023 C40.33297485 118.10274021 41.36927899 116.86372083 43.0703125 114.765625 C45.5441969 111.80436028 48.06204588 108.94863407 50.7421875 106.171875 C51.391875 105.49382812 52.0415625 104.81578125 52.7109375 104.1171875 C54.04772377 102.72756383 55.38900501 101.34225249 56.734375 99.9609375 C57.37632812 99.28804687 58.01828125 98.61515625 58.6796875 97.921875 C59.25831543 97.32342773 59.83694336 96.72498047 60.43310547 96.10839844 C61.92487812 94.16618965 62.40217821 92.70593402 62.8125 90.3125 C49.01274175 79.92526331 34.92471084 75.21385676 17.8125 73.3125 C17.8125 66.3825 17.8125 59.4525 17.8125 52.3125 C12.676875 52.0340625 12.676875 52.0340625 7.4375 51.75 C6.37998535 51.68868896 5.3224707 51.62737793 4.23291016 51.56420898 C-2.03576126 51.25304372 -7.95725857 51.54368593 -14.1875 52.3125 Z ",
    fill: "#FED631",
    transform: "translate(422.1875,275.6875)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.43289851 9.92029945 19.16733123 24.24861233 19.55078125 38.96484375 C19.98804429 60.19376751 14.05269953 74.30448295 0.3125 90.4375 C-7.78281321 100.12328314 -10.21090988 109.08216997 -10.75 121.625 C-11.39344093 135.62976992 -11.39344093 135.62976992 -14.6875 141.4375 C-22.38919239 145.28834619 -34.47139653 143.62363295 -42.9753418 143.62280273 C-45.51172162 143.6250102 -48.04767995 143.64328209 -50.58398438 143.66210938 C-52.20833186 143.66504038 -53.83268139 143.66702713 -55.45703125 143.66796875 C-56.20918411 143.67515427 -56.96133698 143.68233978 -57.73628235 143.68974304 C-62.73213036 143.66803695 -66.61738562 143.23008256 -70.46484375 139.8984375 C-72.36782709 136.06815154 -72.17609598 132.2848567 -72.25 128.0625 C-72.31461616 126.25634786 -72.38364912 124.45034848 -72.45703125 122.64453125 C-72.4926416 121.75846191 -72.52825195 120.87239258 -72.56494141 119.95947266 C-73.29170689 105.00431842 -77.49764819 96.80279644 -87.16357422 85.80297852 C-99.85491489 71.18222431 -104.03416052 55.95318252 -102.90625 36.89501953 C-101.60423709 22.26771822 -93.59894008 8.17029025 -82.6875 -1.5625 C-57.1247913 -21.27535904 -24.87433977 -21.06880795 0 0 Z ",
    fill: "#FED632",
    transform: "translate(465.6875,108.5625)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C9.10526056 7.61106395 15.41171531 17.17686534 19.59765625 28.22265625 C19.90574219 29.01414063 20.21382813 29.805625 20.53125 30.62109375 C22.60959582 36.92574089 22.87098361 43.08318903 23.09765625 49.66015625 C23.70895671 67.0555416 28.26702021 78.19313611 40.37084961 90.66967773 C47.54151142 98.08915287 47.54151142 98.08915287 47.66015625 102.59765625 C45.48963164 107.9601288 41.25551693 111.73532363 36.921875 115.4375 C31.7063867 119.95810947 26.7465719 124.73742435 21.77734375 129.52539062 C11.59106283 139.22265625 11.59106283 139.22265625 6.53515625 139.22265625 C1.00939706 137.34154674 -2.25435513 133.4061002 -5.77734375 128.91015625 C-15.84472132 116.47884602 -25.14257367 110.12314886 -41.40234375 108.22265625 C-59.09041821 105.83724163 -73.89853979 98.74409046 -85.02734375 84.53515625 C-94.87542153 71.01292339 -99.04683803 55.64172954 -97.01171875 39.03515625 C-94.2835477 23.64547341 -86.91830279 9.07457325 -74.10546875 -0.2421875 C-67.3111323 -4.93246532 -60.36583248 -8.50206126 -52.40234375 -10.77734375 C-51.71527344 -11.01195312 -51.02820313 -11.2465625 -50.3203125 -11.48828125 C-33.55791804 -16.42405323 -13.52470866 -10.00608527 0 0 Z ",
    fill: "#FED631",
    transform: "translate(267.40234375,169.77734375)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.54614043 2.21785246 4.96408644 4.51135265 7.35546875 6.89453125 C8.31259766 7.81685547 8.31259766 7.81685547 9.2890625 8.7578125 C21.37531498 21.3285918 23.97116316 36.76325827 23.66796875 53.45703125 C23.39433415 60.08810967 22.05209787 65.82500239 19.35546875 71.89453125 C18.95457031 72.82007813 18.55367187 73.745625 18.140625 74.69921875 C11.08923638 89.12901692 -1.53141153 100.0656564 -16.37109375 105.90234375 C-22.34249036 107.71228974 -28.46062369 108.23340074 -34.64453125 108.89453125 C-51.42709503 111.14482489 -61.18442922 119.98744904 -71.38671875 133.140625 C-74.14234268 136.5759695 -75.96195376 138.60908975 -80.08203125 140.33203125 C-85.47937614 139.66919942 -87.89586024 136.62966915 -91.64453125 132.89453125 C-93.28454908 131.42966095 -94.93062047 129.97154568 -96.58203125 128.51953125 C-100.6863187 124.82378696 -104.5915751 120.97435858 -108.46484375 117.0390625 C-111.23121801 114.31730718 -114.14168546 111.79870539 -117.11328125 109.3046875 C-119.30022767 107.29068838 -119.61932291 106.11636467 -119.95703125 103.14453125 C-119.25686649 95.86281772 -112.80898775 90.72530076 -107.984375 85.67578125 C-105.63252033 82.88025449 -104.13447875 80.21638142 -102.64453125 76.89453125 C-101.98453125 76.89453125 -101.32453125 76.89453125 -100.64453125 76.89453125 C-98.27875689 69.57402192 -97.3985935 62.78969381 -97.14453125 55.14453125 C-96.35236738 34.25878855 -91.24502571 17.45922052 -75.64453125 2.89453125 C-54.56593825 -15.46522874 -22.20783733 -17.68098127 0 0 Z ",
    fill: "#FED631",
    transform: "translate(653.64453125,169.10546875)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.86496094 0.350625 1.72992187 0.70125 2.62109375 1.0625 C17.04560791 7.54340496 26.73449833 19.03109409 32.9921875 33.296875 C35.16167502 39.11581052 36.39075063 44.8047122 37.125 50.9375 C37.25455078 51.96327148 37.25455078 51.96327148 37.38671875 53.00976562 C37.59602285 54.67257046 37.79871722 56.33620513 38 58 C37.34 58 36.68 58 36 58 C36.061875 58.94875 36.12375 59.8975 36.1875 60.875 C36.10652412 74.34398747 28.08002234 86.97883716 18.921875 96.23828125 C7.06208703 107.69250542 -6.91794229 113.84285745 -23.375 114.3125 C-37.66300036 114.06035882 -49.0227068 108.71547733 -60.42114258 100.61694336 C-73.19927012 91.71293574 -86.62622397 93.4087157 -101.34375 95.5625 C-110.43496088 96.6503372 -110.43496088 96.6503372 -114.3125 95.0390625 C-116.92408705 91.88339482 -117.33104947 88.30637082 -118 84.375 C-118.15879639 83.5092334 -118.31759277 82.6434668 -118.48120117 81.75146484 C-119.00698463 78.83741606 -119.50402251 75.91926133 -120 73 C-120.19158691 71.91396484 -120.38317383 70.82792969 -120.58056641 69.70898438 C-121.17194815 66.34989727 -121.7457744 62.98832887 -122.3125 59.625 C-122.49619141 58.56200684 -122.67988281 57.49901367 -122.86914062 56.40380859 C-124.50167023 46.31987326 -124.50167023 46.31987326 -123 42 C-119.92802384 39.12024381 -117.36055529 38.47885848 -113.23828125 37.9375 C-111.55895508 37.70160156 -111.55895508 37.70160156 -109.84570312 37.4609375 C-108.67974609 37.30882812 -107.51378906 37.15671875 -106.3125 37 C-95.79740523 35.60508018 -86.74663619 34.30571446 -78 28 C-77.2575 27.67 -76.515 27.34 -75.75 27 C-73.46092566 25.69195752 -73.17408766 24.35228052 -72 22 C-64.33384346 11.25658344 -56.23218149 4.13751623 -44 -1 C-43.34 -1 -42.68 -1 -42 -1 C-41.67 -1.66 -41.34 -2.32 -41 -3 C-27.67418506 -5.75400175 -12.51922111 -5.3528034 0 0 Z ",
    fill: "#FED631",
    transform: "translate(738,345)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.0983525 1.98120005 6.09483396 4.06835747 9.078125 6.21875 C10.12484375 6.9715625 11.1715625 7.724375 12.25 8.5 C13.80460938 9.62921875 13.80460938 9.62921875 15.390625 10.78125 C26.59428368 17.95203352 36.69509215 17.3486506 49.53417969 16.8425293 C68.49700604 16.15645068 83.7048256 20.34829722 98.1875 33.1875 C109.60158672 43.81136687 115.93815634 57.93115496 117.203125 73.5 C117.4950563 89.06966939 112.84828577 103.7036606 102.5 115.5 C101.01866231 117.01843296 99.52047958 118.52076309 98 120 C97.22462891 120.82371094 97.22462891 120.82371094 96.43359375 121.6640625 C85.69038273 132.15482209 70.47621947 136.34863503 55.94238281 136.2331543 C40.96768399 135.87619518 28.34390442 130.74791125 17.375 120.5625 C16.199375 119.2940625 16.199375 119.2940625 15 118 C14.52949219 117.51144531 14.05898438 117.02289062 13.57421875 116.51953125 C4.67825978 106.84201516 1.07703637 95.56345522 -1.375 82.9375 C-2.7498951 76.32936542 -4.53161661 69.59031164 -10.16015625 65.38671875 C-10.76730469 64.92910156 -11.37445312 64.47148438 -12 64 C-12 63.34 -12 62.68 -12 62 C-12.5259375 61.76023437 -13.051875 61.52046875 -13.59375 61.2734375 C-16.72243314 59.61767337 -19.59656554 57.63962799 -22.5 55.625 C-23.06847656 55.23828125 -23.63695312 54.8515625 -24.22265625 54.453125 C-32.26613514 48.89174052 -32.26613514 48.89174052 -34.0546875 44.28125 C-33.97382848 39.42970892 -31.74982268 36.47249791 -29.125 32.5 C-28.62339355 31.71189941 -28.12178711 30.92379883 -27.60498047 30.11181641 C-26.08525763 27.73096539 -24.54395421 25.36518507 -23 23 C-22.14409943 21.66517271 -21.2898073 20.32931201 -20.4375 18.9921875 C-18.94736973 16.65659106 -17.44588318 14.32911306 -15.93359375 12.0078125 C-14.29036548 9.45167964 -12.73044565 6.86691086 -11.1875 4.25 C-8.02679719 -0.44590132 -5.45433194 -1.81811065 0 0 Z ",
    fill: "#FED631",
    transform: "translate(612,524)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.58677338 2.30471206 6.25486768 5.67797222 8.7890625 10.02734375 C9.82862822 11.74787877 10.86901815 13.46791601 11.91015625 15.1875 C12.44108887 16.0758252 12.97202148 16.96415039 13.51904297 17.87939453 C15.16005518 20.583241 16.85416 23.24428104 18.57421875 25.8984375 C19.12319824 26.74801025 19.67217773 27.59758301 20.23779297 28.47290039 C21.29387706 30.10367957 22.35394789 31.73188557 23.41845703 33.35717773 C28.19646602 40.81807349 28.19646602 40.81807349 28.1640625 44.58984375 C26.14348463 49.75262639 21.83308221 52.36099744 17.4765625 55.46484375 C16.02853506 56.52802631 14.58190406 57.59311359 13.13671875 58.66015625 C12.44723145 59.16708008 11.75774414 59.67400391 11.04736328 60.19628906 C8.79423834 61.86349637 6.57786869 63.55788571 4.4140625 65.33984375 C3.86234375 65.7884375 3.310625 66.23703125 2.7421875 66.69921875 C-2.14515725 72.55435454 -3.66782121 79.40748025 -5.1484375 86.71484375 C-9.0338731 104.15508197 -16.82893655 117.40391079 -31.73046875 127.765625 C-45.85820227 136.06455777 -61.92157198 139.02215611 -78.0234375 135.52734375 C-94.87807313 130.59427966 -107.54556426 119.51595086 -115.94482422 104.34912109 C-118.1689768 99.95809548 -119.64368092 95.35177332 -120.8359375 90.58984375 C-121.02671875 89.83058594 -121.2175 89.07132813 -121.4140625 88.2890625 C-123.05190819 77.80988314 -122.63292982 66.51417133 -118.8359375 56.58984375 C-118.54589844 55.81511719 -118.25585938 55.04039062 -117.95703125 54.2421875 C-111.98573048 39.67621115 -101.15313545 28.21180093 -86.8359375 21.58984375 C-85.91425781 21.40550781 -84.99257812 21.22117187 -84.04296875 21.03125 C-83.31464844 20.88558594 -82.58632812 20.73992188 -81.8359375 20.58984375 C-81.5059375 19.92984375 -81.1759375 19.26984375 -80.8359375 18.58984375 C-75.42838961 17.64991793 -70.12652705 17.43046243 -64.6484375 17.46484375 C-63.91012695 17.46532715 -63.17181641 17.46581055 -62.41113281 17.46630859 C-57.93286773 17.49438246 -53.54466553 17.75976094 -49.0859375 18.21484375 C-32.16890308 19.60528494 -21.12381474 12.43293481 -8.33203125 2.41015625 C-5.29936601 0.19854122 -3.74473672 -0.54159415 0 0 Z ",
    fill: "#FED631",
    transform: "translate(241.8359375,523.41015625)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.42022461 -0.00580078 1.42022461 -0.00580078 2.86914062 -0.01171875 C8.7148982 -0.00367228 14.40854458 0.20176951 20.1875 1.125 C20.6825 2.115 20.6825 2.115 21.1875 3.125 C23.31113335 4.19124706 25.4623536 5.20278587 27.625 6.1875 C37.93147659 11.12736049 45.90027891 18.54996604 52.1875 28.125 C52.6825 29.61 52.6825 29.61 53.1875 31.125 C55.04447904 32.24643027 55.04447904 32.24643027 57.1875 33.125 C57.7546875 33.44339844 58.321875 33.76179688 58.90625 34.08984375 C67.93899889 39.02220005 77.48961401 40.41796532 87.66796875 40.81640625 C88.49941406 40.91824219 89.33085937 41.02007812 90.1875 41.125 C90.5175 41.785 90.8475 42.445 91.1875 43.125 C92.30125 43.24875 93.415 43.3725 94.5625 43.5 C98.1875 44.125 98.1875 44.125 100.125 45.75 C102.71399291 51.53716061 100.77486249 58.38086272 99.61328125 64.3828125 C99.44757126 65.2488913 99.28186127 66.11497009 99.11112976 67.0072937 C98.75920906 68.8283404 98.40349587 70.64865787 98.04418945 72.46826172 C97.50094985 75.24514467 96.98565239 78.02634519 96.47070312 80.80859375 C96.12410756 82.58366842 95.77585602 84.35842071 95.42578125 86.1328125 C95.20200554 87.37359055 95.20200554 87.37359055 94.97370911 88.63943481 C93.90934937 93.82079693 92.57065482 96.79778702 88.1875 100.125 C84.69921875 100.4296875 84.69921875 100.4296875 80.875 100 C80.2042041 99.93304932 79.5334082 99.86609863 78.84228516 99.79711914 C75.57289191 99.46001508 72.31754344 99.01555744 69.0625 98.5625 C54.52136231 96.92075865 45.88832371 99.31098261 34.14892578 107.75976562 C21.24928028 116.8867662 5.78592759 120.04336645 -9.75 117.4375 C-25.71832696 113.77388068 -39.44530577 104.44239913 -48.5 90.8125 C-57.36303982 76.26598621 -60.17851687 60.65447996 -56.1875 44 C-54.38925504 37.10249874 -51.74861761 31.10065555 -47.8125 25.125 C-47.31105469 24.34769531 -46.80960938 23.57039063 -46.29296875 22.76953125 C-39.13752187 12.65441048 -26.57278149 3.28045874 -14.30078125 0.5703125 C-9.52340426 -0.03956541 -4.81091647 -0.0194119 0 0 Z ",
    fill: "#FED631",
    transform: "translate(131.8125,340.875)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.86245627 0.65193493 5.60838655 1.56507813 8.3828125 2.51953125 C9.16010712 2.77876877 9.93740173 3.03800629 10.73825073 3.30509949 C12.37194583 3.8524449 14.00394123 4.40488731 15.63427734 4.9621582 C18.12060329 5.81099895 20.61235496 6.64203865 23.10546875 7.47070312 C24.69826733 8.00677172 26.29072745 8.54384724 27.8828125 9.08203125 C28.99234787 9.45253349 28.99234787 9.45253349 30.1242981 9.83052063 C40.13743033 13.27486065 40.13743033 13.27486065 42 17 C41.95997347 22.51419968 40.65461448 27.48930982 38.77563477 32.62988281 C32.75343627 49.21066353 33.45787534 61.54553211 40.62133789 77.68261719 C47.28235549 92.74789759 46.86523483 106.70468623 41.2578125 122.15625 C39.045909 127.1570753 36.20641085 131.58349379 33 136 C32.48824219 136.70898438 31.97648437 137.41796875 31.44921875 138.1484375 C22.60428798 149.25398333 9.29400327 156.3012082 -4.57421875 158.58984375 C-19.16840605 160.01875758 -33.59796234 157.01848836 -45.13671875 147.58203125 C-46.05904297 146.79892578 -46.05904297 146.79892578 -47 146 C-47.66644531 145.48824219 -48.33289063 144.97648438 -49.01953125 144.44921875 C-54.79420165 139.82285757 -58.34482334 134.37791029 -62 128 C-62.60328125 127.04867187 -62.60328125 127.04867187 -63.21875 126.078125 C-70.43198972 113.72818426 -70.30048173 97.33976022 -66.83007812 83.96191406 C-62.24384073 67.72602013 -51.01435862 56.04627181 -37.05078125 47.11328125 C-24.49185565 39.00327394 -20.05033896 31.55806837 -15.49609375 17.36328125 C-15.10744141 16.15828979 -15.10744141 16.15828979 -14.7109375 14.92895508 C-14.20429725 13.33786802 -13.71029834 11.74268728 -13.23046875 10.14331055 C-10.79411423 2.39181176 -8.60100785 -0.55213009 0 0 Z ",
    fill: "#FED632",
    transform: "translate(346,623)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.495 0.99 0.495 0.99 1 2 C1.93005859 2.33064453 1.93005859 2.33064453 2.87890625 2.66796875 C6.12285075 4.705142 6.77197168 7.83685749 7.9375 11.3125 C8.45406316 12.76445244 8.97099568 14.21627352 9.48828125 15.66796875 C9.86847412 16.75924072 9.86847412 16.75924072 10.25634766 17.87255859 C14.98882967 31.41124812 19.19588396 40.33627123 31.47265625 48.34375 C48.25877462 59.34423561 58.76665557 71.64609138 63.58984375 91.41796875 C66.07776379 107.08001773 62.64808105 121.81000042 54 135 C44.66924548 147.17425089 33.03595114 155.48851758 18 159 C0.45632865 160.67373209 -14.46303854 157.89597028 -28.59375 147 C-41.29823198 136.28537664 -48.17464152 121.68174211 -49.75 105.3125 C-50.48342195 92.57268912 -47.59243254 81.4018304 -42.0078125 69.96875 C-36.71352745 58.47258819 -40.05483089 46.67571128 -44.0625 35.4375 C-44.45155518 34.41462891 -44.84061035 33.39175781 -45.24145508 32.33789062 C-48.87451446 22.59413923 -48.87451446 22.59413923 -47 17 C-43.66172464 13.80799062 -39.52716147 12.58792703 -35.234375 11.15234375 C-34.48214661 10.8949794 -33.72991821 10.63761505 -32.95489502 10.37245178 C-31.36579586 9.83038426 -29.77549194 9.29183739 -28.18408203 8.7565918 C-25.76963505 7.94410738 -23.3592129 7.12050871 -20.94921875 6.29492188 C-19.39866297 5.76756578 -17.84788839 5.24085244 -16.296875 4.71484375 C-15.58513123 4.47209213 -14.87338745 4.22934052 -14.14007568 3.97923279 C-9.47084945 2.41368922 -4.79075973 1.14259284 0 0 Z ",
    fill: "#FED631",
    transform: "translate(507,622)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3.92880786 -1.14189929 4.57467074 -3.875 7.3125 C-12.42832834 15.55796207 -24.55561427 22.85926024 -36.75 23.0625 C-37.8225 23.041875 -38.895 23.02125 -40 23 C-37.02176526 20.49383976 -34.58833519 19.43971424 -30.8125 18.5625 C-24.1134209 16.83860365 -17.91108698 14.84772676 -12.625 10.25 C-10 8 -10 8 -7 8 C-6.6596875 7.13375 -6.6596875 7.13375 -6.3125 6.25 C-4.66961977 3.4336339 -2.60466773 1.91922886 0 0 Z ",
    fill: "#FAD128",
    transform: "translate(558,758)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0 5.28 0 8 0 C7.34 0.66 6.68 1.32 6 2 C5.01 2 4.02 2 3 2 C3 2.66 3 3.32 3 4 C2.40574219 4.268125 1.81148437 4.53625 1.19921875 4.8125 C-9.74051325 9.98462835 -19.57137553 17.33055769 -28 26 C-24.20954916 14.28406103 -11.8811844 7.2193471 -1.546875 1.77734375 C-1.03640625 1.52082031 -0.5259375 1.26429688 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FBD128",
    transform: "translate(112,342)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.475 0.99 2.475 0.99 5 2 C5 2.66 5 3.32 5 4 C5.66 4 6.32 4 7 4 C7.66 5.32 8.32 6.64 9 8 C9.66 8 10.32 8 11 8 C11 8.66 11 9.32 11 10 C11.56203125 10.27585937 12.1240625 10.55171875 12.703125 10.8359375 C15.08618794 12.04368028 17.4179008 13.32176809 19.75 14.625 C20.54921875 15.07101562 21.3484375 15.51703125 22.171875 15.9765625 C22.77515625 16.31429687 23.3784375 16.65203125 24 17 C24 17.66 24 18.32 24 19 C24.99 19.33 25.98 19.66 27 20 C24.44812949 20.96714727 23.3449431 21.13918757 20.7734375 20.1015625 C13.04086101 15.34111639 5.05438327 9.70346518 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FBD129",
    transform: "translate(288,756)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.6875 1.6875 0.6875 1.6875 1 4 C0.55398437 4.70253906 0.10796875 5.40507812 -0.3515625 6.12890625 C-2.42146867 9.73407457 -3.18138914 13.21792065 -4.0625 17.25 C-4.63668499 19.86957492 -5.2711171 22.414974 -6 25 C-6.66 25.33 -7.32 25.66 -8 26 C-8.84954834 16.65496821 -4.93967964 7.76235373 0 0 Z ",
    fill: "#FBD127",
    transform: "translate(83,368)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.98839844 0.99 0.97679687 1.98 0.96484375 3 C0.82254801 11.3048716 0.82254801 11.3048716 1.5625 19.5625 C2.00018731 23.00147174 1.75710599 25.63508448 1 29 C-2.99109182 22.61425309 -3.03558946 12.05187555 -1.55078125 4.80859375 C-1.08940411 3.1888655 -0.55328067 1.59068192 0 0 Z ",
    fill: "#FBD228",
    transform: "translate(279,710)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.26169766 3.68713736 2.63948566 7.539556 3.125 11.75 C3.21136719 12.44738281 3.29773438 13.14476562 3.38671875 13.86328125 C3.59771846 15.57472332 3.79975501 17.28726629 4 19 C3.34 19 2.68 19 2 19 C2.061875 20.485 2.061875 20.485 2.125 22 C2.1423348 26.23835866 1.14191162 29.93193985 0 34 C-2 31 -2 31 -1.6875 27.9375 C-1 25 -1 25 0 23 C0.09735819 20.68917466 0.12977373 18.37537042 0.125 16.0625 C0.12757813 14.81597656 0.13015625 13.56945312 0.1328125 12.28515625 C0.15199431 8.99323703 0.15199431 8.99323703 -1 6 C-0.72428861 3.99124558 -0.39764263 1.98821313 0 0 Z ",
    fill: "#F7CE2A",
    transform: "translate(772,384)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C2.48032656 9.71703754 1.07313419 17.54704214 -1 26 C-1.33 26 -1.66 26 -2 26 C-2 22.04 -2 18.08 -2 14 C-1.34 14 -0.68 14 0 14 C-0.08378906 13.24074219 -0.16757812 12.48148438 -0.25390625 11.69921875 C-0.35574219 10.70535156 -0.45757813 9.71148438 -0.5625 8.6875 C-0.66691406 7.70136719 -0.77132812 6.71523438 -0.87890625 5.69921875 C-1 3 -1 3 0 0 Z ",
    fill: "#F7CF29",
    transform: "translate(727,594)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.50143624 5.36809745 0.17472558 9.1719078 -2.4375 13.875 C-3.05496094 15.00679687 -3.67242188 16.13859375 -4.30859375 17.3046875 C-6 20 -6 20 -8 21 C-7.54979057 15.14727744 -4.96160773 10.91779881 -2 6 C-1.34 6 -0.68 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FAD228",
    transform: "translate(567,737)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C0.58791833 2.60820412 -0.82986036 4.21140708 -2.25 5.8125 C-3.03890625 6.70582031 -3.8278125 7.59914062 -4.640625 8.51953125 C-7 11 -7 11 -9.234375 12.63671875 C-11.29959801 13.96940082 -11.29959801 13.96940082 -12 17 C-12.99 17.33 -13.98 17.66 -15 18 C-13.59965804 13.79897412 -11.61302173 11.12112327 -8.625 7.875 C-7.85414063 7.02679688 -7.08328125 6.17859375 -6.2890625 5.3046875 C-4.29150783 3.29349764 -2.31828562 1.6196242 0 0 Z ",
    fill: "#FAD028",
    transform: "translate(194,169)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.73605469 0.10441406 1.47210938 0.20882812 2.23046875 0.31640625 C4.03045935 0.57354776 5.82802654 0.84755754 7.625 1.125 C7.625 1.455 7.625 1.785 7.625 2.125 C-6.97181093 3.45757403 -6.97181093 3.45757403 -14.375 2.125 C-14.375 1.795 -14.375 1.465 -14.375 1.125 C-9.16979624 -1.09172715 -5.41303392 -0.85159847 0 0 Z ",
    fill: "#F9CD28",
    transform: "translate(337.375,778.875)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.62651431 0.28119857 5.25069335 0.57443838 7.875 0.875 C8.62136719 0.95363281 9.36773437 1.03226562 10.13671875 1.11328125 C15.7734375 1.7734375 15.7734375 1.7734375 18 4 C15.75026553 4.054138 13.50015617 4.09285491 11.25 4.125 C9.99703125 4.14820312 8.7440625 4.17140625 7.453125 4.1953125 C4.27179508 4.01537302 2.63478104 3.68998582 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#F8CF29",
    transform: "translate(424,92)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.48749314 2.78999451 6.50157221 5.25235831 9 9 C8.67 9.66 8.34 10.32 8 11 C7.01 10.67 6.02 10.34 5 10 C4.6278958 8.67696283 4.29369827 7.34262065 4 6 C3.34 5.67 2.68 5.34 2 5 C1.34 4.34 0.68 3.68 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#F9D029",
    transform: "translate(755,356)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.49223987 0.99689595 3.76416902 1.61522314 5.1875 3.9375 C5.84445608 5.60515774 6.43319548 7.29958645 7 9 C6.34 9.66 5.68 10.32 5 11 C4.15841464 9.73461631 3.32700252 8.46246221 2.5 7.1875 C1.80390625 6.12595703 1.80390625 6.12595703 1.09375 5.04296875 C0 3 0 3 0 0 Z ",
    fill: "#FACF28",
    transform: "translate(282,745)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C4 2.65 4 4.3 4 6 C4.66 6 5.32 6 6 6 C6.33 6.99 6.66 7.98 7 9 C6.34 9.66 5.68 10.32 5 11 C4.16151196 9.54462432 3.32936066 8.08559627 2.5 6.625 C1.80390625 5.40683594 1.80390625 5.40683594 1.09375 4.1640625 C0 2 0 2 0 0 Z ",
    fill: "#FACF28",
    transform: "translate(124,622)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C4.23076923 6.41538462 4.23076923 6.41538462 3.0625 9.375 C2.711875 9.91125 2.36125 10.4475 2 11 C0.80712589 7.12315913 0 4.08378077 0 0 Z ",
    fill: "#FAD12A",
    transform: "translate(121,610)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.14809171 3.22213757 2.29386153 4.27775401 2 8 C1.67 8.33 1.34 8.66 1 9 C0.76924918 10.34747084 0.58846937 11.70377565 0.4375 13.0625 C0.293125 14.361875 0.14875 15.66125 0 17 C-0.33 17 -0.66 17 -1 17 C-1.10477512 11.21408489 -0.99250545 5.70690634 0 0 Z ",
    fill: "#F4CC2B",
    transform: "translate(171,205)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C0.64978174 4.41889613 -1.26115668 6.34345343 -5 9 C-5.33 8.34 -5.66 7.68 -6 7 C-5.34 6.01 -4.68 5.02 -4 4 C-3.01 4 -2.02 4 -1 4 C-0.67 2.68 -0.34 1.36 0 0 Z ",
    fill: "#FAD229",
    transform: "translate(717,632)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0 5.94 0 9 0 C9 0.66 9 1.32 9 2 C9.99 2.33 10.98 2.66 12 3 C8.52128379 4.15957207 7.65780355 3.77456651 4.3125 2.5625 C3.50425781 2.27503906 2.69601563 1.98757813 1.86328125 1.69140625 C1.24839844 1.46324219 0.63351563 1.23507812 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FCD226",
    transform: "translate(111,454)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.35455571 4.48539917 -0.10134397 7.02819057 -2 10 C-2.6875 8.375 -2.6875 8.375 -3 6 C-1.5625 2.75 -1.5625 2.75 0 0 Z ",
    fill: "#FAD229",
    transform: "translate(766,423)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 4.62 1 9.24 1 14 C-0.32 13.67 -1.64 13.34 -3 13 C-2.68289063 12.43796875 -2.36578125 11.8759375 -2.0390625 11.296875 C-0.93125475 8.84803683 -0.61024601 6.91612145 -0.375 4.25 C-0.30023438 3.45078125 -0.22546875 2.6515625 -0.1484375 1.828125 C-0.09945313 1.22484375 -0.05046875 0.6215625 0 0 Z ",
    fill: "#FED026",
    transform: "translate(406,333)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.28330144 2.92348758 3.95866933 5.75457495 5 10 C4.01 9.67 3.02 9.34 2 9 C1.26953125 6.93359375 1.26953125 6.93359375 0.8125 4.4375 C0.65394531 3.61121094 0.49539063 2.78492188 0.33203125 1.93359375 C0.16767578 0.97646484 0.16767578 0.97646484 0 0 Z ",
    fill: "#FAD129",
    transform: "translate(719,569)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2.5654594 2.5654594 -4.47686668 2.54046087 -8 3 C-8.33 2.01 -8.66 1.02 -9 0 C-3.375 -1.125 -3.375 -1.125 0 0 Z ",
    fill: "#FACF29",
    transform: "translate(354,777)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.93673644 1.31224548 6.22719294 2.91910327 9 6 C2.35384615 4.52307692 2.35384615 4.52307692 0.5625 1.875 C0.376875 1.25625 0.19125 0.6375 0 0 Z ",
    fill: "#F8CF29",
    transform: "translate(646,165)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.0326802 2.78823655 1.04509293 3.8677274 0.0625 6.75 C-0.288125 7.4925 -0.63875 8.235 -1 9 C-1.66 8.01 -2.32 7.02 -3 6 C-1.65517241 1.65517241 -1.65517241 1.65517241 0 0 Z ",
    fill: "#FAD229",
    transform: "translate(674,232)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#ECC52C",
    transform: "translate(667,661)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#ECC82C",
    transform: "translate(178,661)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#F5D02F",
    transform: "translate(128,460)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#ECC62D",
    transform: "translate(173,661)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#FED632",
    transform: "translate(264,496)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#E9C730",
    transform: "translate(72,398)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#FED62E",
    transform: "translate(427,252)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FED832",
    transform: "translate(456,526)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#E6C02A",
    transform: "translate(316,780)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ECC62C",
    transform: "translate(0,0)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F2C92D",
    transform: "translate(0,0)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FCD833",
    transform: "translate(306,670)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#EBC72E",
    transform: "translate(664,661)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#E7C12C",
    transform: "translate(700,652)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD933",
    transform: "translate(0,0)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FCD831",
    transform: "translate(350,623)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FBD632",
    transform: "translate(347,622)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD833",
    transform: "translate(0,0)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EEC932",
    transform: "translate(0,0)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#F6D231",
    transform: "translate(686,542)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FED732",
    transform: "translate(0,0)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#F6D02E",
    transform: "translate(716,460)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FCD934",
    transform: "translate(397,454)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD832",
    transform: "translate(0,0)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD833",
    transform: "translate(0,0)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E7C12D",
    transform: "translate(0,0)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDD834",
    transform: "translate(0,0)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FDD833",
    transform: "translate(472,374)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#EDC92F",
    transform: "translate(733,342)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FED62F",
    transform: "translate(434,252)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FED630",
    transform: "translate(424,252)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDD532",
    transform: "translate(0,0)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#E8C52F",
    transform: "translate(600,158)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#E8C22E",
    transform: "translate(401,94)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#312601",
    transform: "translate(0,0)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E5C02B",
    transform: "translate(0,0)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E7C22C",
    transform: "translate(0,0)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EBC52D",
    transform: "translate(0,0)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E8C32A",
    transform: "translate(0,0)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E7C42D",
    transform: "translate(0,0)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EDC42B",
    transform: "translate(0,0)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAD132",
    transform: "translate(0,0)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBD430",
    transform: "translate(0,0)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAD332",
    transform: "translate(0,0)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EFCB2C",
    transform: "translate(0,0)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDD535",
    transform: "translate(0,0)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCD833",
    transform: "translate(0,0)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F3CC30",
    transform: "translate(0,0)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCD534",
    transform: "translate(0,0)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8D031",
    transform: "translate(0,0)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FED833",
    transform: "translate(0,0)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD833",
    transform: "translate(0,0)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EFC92F",
    transform: "translate(0,0)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EBC42D",
    transform: "translate(0,0)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9D22E",
    transform: "translate(0,0)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8D130",
    transform: "translate(0,0)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD634",
    transform: "translate(0,0)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD731",
    transform: "translate(0,0)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E7C52D",
    transform: "translate(0,0)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFDA32",
    transform: "translate(0,0)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9D22F",
    transform: "translate(0,0)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBD733",
    transform: "translate(0,0)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCD634",
    transform: "translate(0,0)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E6C22D",
    transform: "translate(0,0)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E8C22C",
    transform: "translate(0,0)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E9C52E",
    transform: "translate(0,0)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ECC52F",
    transform: "translate(0,0)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFDA32",
    transform: "translate(0,0)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EAC42C",
    transform: "translate(0,0)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFDA36",
    transform: "translate(0,0)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD833",
    transform: "translate(0,0)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD832",
    transform: "translate(0,0)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD731",
    transform: "translate(0,0)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD933",
    transform: "translate(0,0)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FED933",
    transform: "translate(0,0)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD930",
    transform: "translate(0,0)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EEC932",
    transform: "translate(0,0)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD931",
    transform: "translate(0,0)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F6CE31",
    transform: "translate(0,0)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDD532",
    transform: "translate(0,0)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDD431",
    transform: "translate(0,0)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCD22F",
    transform: "translate(0,0)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDD731",
    transform: "translate(0,0)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD72F",
    transform: "translate(0,0)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBD631",
    transform: "translate(0,0)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD932",
    transform: "translate(0,0)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FED832",
    transform: "translate(0,0)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD932",
    transform: "translate(0,0)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FED731",
    transform: "translate(0,0)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD72F",
    transform: "translate(0,0)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD732",
    transform: "translate(0,0)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD831",
    transform: "translate(0,0)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD832",
    transform: "translate(0,0)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD732",
    transform: "translate(0,0)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FED82E",
    transform: "translate(0,0)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFDA31",
    transform: "translate(0,0)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD732",
    transform: "translate(0,0)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD933",
    transform: "translate(0,0)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFDA33",
    transform: "translate(0,0)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD734",
    transform: "translate(0,0)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8D130",
    transform: "translate(0,0)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAD12F",
    transform: "translate(0,0)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F6CF2E",
    transform: "translate(0,0)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAD332",
    transform: "translate(0,0)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD832",
    transform: "translate(0,0)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F2CE30",
    transform: "translate(0,0)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FED832",
    transform: "translate(0,0)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD732",
    transform: "translate(0,0)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD935",
    transform: "translate(0,0)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EBC72C",
    transform: "translate(0,0)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDD834",
    transform: "translate(0,0)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD933",
    transform: "translate(0,0)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD732",
    transform: "translate(0,0)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDD833",
    transform: "translate(0,0)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E6C22E",
    transform: "translate(0,0)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCD732",
    transform: "translate(0,0)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FED731",
    transform: "translate(0,0)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E7C331",
    transform: "translate(0,0)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD833",
    transform: "translate(0,0)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E9C52F",
    transform: "translate(0,0)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E7C630",
    transform: "translate(0,0)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E9C631",
    transform: "translate(0,0)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD832",
    transform: "translate(0,0)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E7C32F",
    transform: "translate(0,0)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E6C331",
    transform: "translate(0,0)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EAC72F",
    transform: "translate(0,0)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FED733",
    transform: "translate(0,0)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD933",
    transform: "translate(0,0)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD832",
    transform: "translate(0,0)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD934",
    transform: "translate(0,0)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E7C12C",
    transform: "translate(0,0)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EAC42D",
    transform: "translate(0,0)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E8C32C",
    transform: "translate(0,0)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E9C62F",
    transform: "translate(0,0)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FED634",
    transform: "translate(0,0)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAD42F",
    transform: "translate(0,0)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EBC630",
    transform: "translate(0,0)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD830",
    transform: "translate(0,0)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD932",
    transform: "translate(0,0)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFDA33",
    transform: "translate(0,0)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD831",
    transform: "translate(0,0)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD632",
    transform: "translate(0,0)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FED430",
    transform: "translate(0,0)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FED733",
    transform: "translate(0,0)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAD62E",
    transform: "translate(0,0)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDD630",
    transform: "translate(0,0)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FED532",
    transform: "translate(0,0)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FED632",
    transform: "translate(0,0)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FED72E",
    transform: "translate(0,0)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD933",
    transform: "translate(0,0)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD831",
    transform: "translate(0,0)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCD431",
    transform: "translate(0,0)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FED52F",
    transform: "translate(0,0)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD730",
    transform: "translate(0,0)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FED730",
    transform: "translate(0,0)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F0CA31",
    transform: "translate(0,0)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCD832",
    transform: "translate(0,0)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDD634",
    transform: "translate(0,0)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFD833",
    transform: "translate(0,0)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDD631",
    transform: "translate(0,0)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EAC62F",
    transform: "translate(0,0)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FED635",
    transform: "translate(0,0)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDD831",
    transform: "translate(0,0)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EAC52F",
    transform: "translate(0,0)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ECC430",
    transform: "translate(0,0)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCD834",
    transform: "translate(0,0)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCD733",
    transform: "translate(0,0)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBD431",
    transform: "translate(0,0)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCD332",
    transform: "translate(0,0)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDD432",
    transform: "translate(0,0)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F0CC33",
    transform: "translate(0,0)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E3C22C",
    transform: "translate(0,0)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EFCB30",
    transform: "translate(0,0)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E1BE2E",
    transform: "translate(0,0)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E7C32B",
    transform: "translate(0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.035ffdad0fe370c9a5d93681c06493ac.svg";
export { ForwardRef as ReactComponent };